// dateString is assumed to be a date without time
export const formatDateString = (dateString: string): string => {
  const localeDate = new Date(dateString);
  // if this is a valid date, continue
  if (localeDate instanceof Date && !isNaN(localeDate.valueOf())) {
    // correct the date based on the locale timezone offset, to get the original intended date
    const date = new Date(
      localeDate.getTime() - localeDate.getTimezoneOffset() * -60000
    );
    const newStr =
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "/" +
      ("0" + date.getDate()).slice(-2) +
      "/" +
      date.getFullYear();
    return newStr;
  }
  // otherwise, return empty string
  return "";
};

// localeDateString is assumed to be a date without a time
export const formatLocaleDateStringToIso = (
  localeDateString: string
): string => {
  const localeDate = new Date(localeDateString);
  // if this is a valid date, continue
  if (localeDate instanceof Date && !isNaN(localeDate.valueOf())) {
    // split on T to get just the date portion
    return localeDate.toISOString().split("T")[0];
  }
  // otherwise, return empty string
  return "";
};
